import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import http from './utils/request'
import { ElMessage, ElMessageBox } from './utils/messageBox'
import './styles/global.css'

const app = createApp(App)
app.use(router)
// 全局挂载 $http，组件中可通过 this.$http 或 inject 使用
app.config.globalProperties.$http = http
app.provide('$http', http)

// 全局消息提示：所有页面直接使用 $message / $confirm，无需 import
app.config.globalProperties.$message = ElMessage
app.config.globalProperties.$confirm = ElMessageBox.confirm
window.$message = ElMessage
window.$confirm = ElMessageBox.confirm

app.mount('#app')